import { useState, useEffect } from 'react';
import { supabase } from '../services/supabaseClient';

/**
 * Hook para verificar se o usuário logado é gustavo.vieira@hendrios.agency
 * @returns {boolean} true se o usuário for gustavo.vieira@hendrios.agency, false caso contrário
 */
export const useIsAdmin = () => {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdmin = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();

        if (session && session.user && session.user.email === 'gustavo.vieira@hendrios.agency') {
          setIsAdmin(true);
        } else {
          setIsAdmin(false);
        }
      } catch (error) {
        console.error('Erro ao verificar admin:', error);
        setIsAdmin(false);
      }
    };

    checkAdmin();

    // Listener para mudanças na autenticação
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (session && session.user && session.user.email === 'gustavo.vieira@hendrios.agency') {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return isAdmin;
};
